'use client';

import GlobalDialogActions from '@/app/components/Common/GlobalDialogActions';
import LoadingGlobalJoy from '@/app/components/MUI/LoadingGlobalJoy';
import { PostProvider } from '@/app/contexts/feeds-context';
import { GlobalDialogProvider } from '@/app/contexts/global-dialog';
import { GlobalDialogV2Provider } from '@/app/contexts/GlobalDialogV2';
import { PointsProvider } from '@/app/contexts/points-context';
import { TokenGuard } from '@/app/contexts/token-guard';
import { VideoProvider } from '@/app/contexts/VideoContext';
import { GlobalPostStateProvider } from '@/app/contexts/global-post-state-context';
import { usePathname } from 'next/navigation';
import * as React from 'react';

function MainLayoutContent({
    children,
    modal,
}: Readonly<{
    children: React.ReactNode;
    modal: React.ReactNode;
}>) {
    const pathname = usePathname();
    const postProviderKey = pathname.includes('/community') ? 'community' : 'other';

    return (
        <TokenGuard>
            <GlobalPostStateProvider>
                <VideoProvider>
                    <PostProvider key={postProviderKey}>
                        <PointsProvider>
                            <GlobalDialogV2Provider>
                                <GlobalDialogProvider>
                                    {children}
                                    {modal}
                                    <LoadingGlobalJoy />
                                </GlobalDialogProvider>
                                {/* dialog v2 */}
                                <GlobalDialogActions />
                                {/* dialog v2 */}
                            </GlobalDialogV2Provider>
                        </PointsProvider>
                    </PostProvider>
                </VideoProvider>
            </GlobalPostStateProvider>
        </TokenGuard>
    );
}

export default function RootLayout({
    children,
    modal,
}: Readonly<{
    children: React.ReactNode;
    modal: React.ReactNode;
}>) {
    return <MainLayoutContent children={children} modal={modal} />;
}
